import { Loader2 } from 'lucide-react';
import { SlideOver } from '../common/SlideOver';
import { ActivityDetail } from './ActivityDetail';
import { useActivityStore } from '../../store/activityStore';
import { useAuthStore } from '../../store/authStore';

const TYPE_TITLES: Record<string, string> = {
  CALL: 'Call', TEXT: 'Text', EMAIL: 'Email', IN_PERSON: 'In-person visit', NOTE: 'Note', OTHER: 'Activity',
};

/**
 * Global, store-driven activity detail overlay. Any list can open it by calling
 * `useActivityStore().openActivityDetail(id)`; the store fetches the activity and
 * this panel renders it inside the SlideOver. Mounted once in the authenticated
 * layout so it overlays every page.
 */
export const ActivityDetailPanel = () => {
  const { openActivityDetailId, detailActivity, isLoadingDetail, detailError, closeActivityDetail } = useActivityStore();
  const { user } = useAuthStore();

  if (!openActivityDetailId) return null;

  // Mirror the authStore role helpers: roles is the canonical multi-role array.
  const isManager = !!user?.roles?.some((r) => r === 'MANAGER' || r === 'ADMIN');
  const canDelete = !!detailActivity && (isManager || detailActivity.createdBy.id === user?.id);
  const title = detailActivity ? (TYPE_TITLES[detailActivity.type] ?? 'Activity') : 'Activity';

  return (
    <SlideOver isOpen title={title} onClose={closeActivityDetail}>
      {isLoadingDetail && (
        <div className="flex items-center justify-center py-12">
          <Loader2 className="w-6 h-6 text-gray-400 animate-spin" />
        </div>
      )}
      {detailError && <p className="text-sm text-red-600 dark:text-red-400 py-8 text-center">{detailError}</p>}
      {detailActivity && !isLoadingDetail && (
        <ActivityDetail activity={detailActivity} canDelete={canDelete} onClose={closeActivityDetail} />
      )}
    </SlideOver>
  );
};
